import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

interface PermissionRouterProps {
  children: React.ReactNode;
}

const PermissionRouter: React.FC<PermissionRouterProps> = ({ children }) => {
  const { user, loading, hasAdminAccess, hasUserAccess, getDefaultPortal } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      const defaultPortal = getDefaultPortal();
      
      // If user is on the root path and has a default portal, redirect them
      if (window.location.pathname === '/' && defaultPortal === 'user') {
        navigate('/user');
      }
    }
  }, [user, loading, navigate, getDefaultPortal]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
};

export default PermissionRouter; 